import React from "react";
import {ShowroomCarCard} from "./ShowroomCarCard/ShowroomCarCard";
import {Waiting} from "../../Components/System/Waiting";
import {ShowroomCarView} from "./ShowroomCarView";
import {Drawer} from "@mantine/core";

export const Showroom = ({selected, selectedCar, cars, hidePrices, changeCar, open, close, opened, fnCardClicked, equipmentBaseIcons, fnUpdateData}) => {
    if (cars) {
        return (
            <>
                <div className="max-h-screen style={{height: '92vh'}} w-full p-8 flex justify-between">
                    <div className="flex flex-wrap overflow-y-scroll">
                        {cars.map((car) => (
                            <div key={"card_" + car.hash} className="mr-8 mb-8">
                                <ShowroomCarCard car={car} hidePrices={hidePrices} fnCardClicked={fnCardClicked} equipmentBaseIcons={equipmentBaseIcons} fnAfterUpdate={fnUpdateData} />
                            </div>
                        ))}
                    </div>
                </div>

                <Drawer
                    position="right"
                    size="1100px"
                    padding="md"
                    opened={opened}
                    onClose={() => {
                        close();
                        fnCardClicked(null);
                    }}
                    withOverlay={true}
                    withCloseButton={false}
                    lockScroll={true}
                    keepMounted={true}
                >
                    <ShowroomCarView car={selectedCar} changeCar={changeCar} hidePrices={hidePrices} close={() => {close();fnCardClicked(null);}} equipmentBaseIcons={equipmentBaseIcons} fnUpdateData={fnUpdateData}/>
                </Drawer>
            </>
        )
    } else {
        return (
            <Waiting/>
        )
    }

}